import { Github } from '@styled-icons/boxicons-logos/Github'
// import { Codepen } from 'styled-icons/boxicons-logos/Codepen'
import { Codepen } from '@styled-icons/boxicons-logos/Codepen'
import { Twitter } from '@styled-icons/boxicons-logos/Twitter'
import { LinkedinSquare as Linkedin } from '@styled-icons/boxicons-logos/LinkedinSquare'

const Icons = {
  Github,
  Codepen,
  Twitter,
  Linkedin,
}

export default Icons
